import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { Navigate, useLocation } from 'react-router-dom'

import { getPathFromPageId } from 'helpers'

import {
  selectCurrentVariantCohort,
  selectLanguage,
} from 'root-redux/selects/common'
import { selectUUID } from 'root-redux/selects/user'

interface IProps {
  isAvailable: boolean
  availableRoute: string
  children: React.ReactElement
}

export const ProtectedRoute: React.FC<IProps> = ({
  isAvailable,
  availableRoute,
  children,
}) => {
  const { search, hash } = useLocation()
  const uuid = useSelector(selectUUID)
  const cohort = useSelector(selectCurrentVariantCohort)
  const language = useSelector(selectLanguage)

  const pathToRedirect = useMemo(
    () =>
      getPathFromPageId({
        pageId: availableRoute,
        cohort,
        uuid,
        language,
        currentSearch: search,
        hash,
      }),
    [availableRoute, cohort, uuid, language, search, hash],
  )

  return isAvailable ? children : <Navigate to={`/${pathToRedirect}`} />
}
